import { useQuery } from '@tanstack/react-query';

export const useIosInitiatedChangeUser = () => {
  const iosInitiatedChangeUserQuery = useQuery({
    queryKey: ['iosInitiatedChangeUser'],
    queryFn: () => sessionStorage.getItem('ios_initiated_change_user'),
  });

  return iosInitiatedChangeUserQuery;
};
